import adminUser from "@/router/other/adminUser"
import appReleaseEula from "@/router/other/appReleaseEula"
import batchBanUsers from "@/router/other/batchBanUsers"
import suspiciousCrews from "@/router/other/suspiciousCrews"
import cancelMatchesPayment from "@/router/other/cancelMatchesPayment"
import carpoolPlace from "@/router/other/carpoolPlace"
import karosEvent from "@/router/other/karosEvent"
import kpiDeployment from "@/router/other/kpiDeployment"
import paymentLogs from "@/router/other/paymentLogs"
import prizes from "@/router/other/prizes"
import promoCodeTemplate from "@/router/other/promoCodeTemplate"
import segment from "@/router/other/segment"
import shareConfig from "@/router/other/shareConfig"
import spot from "@/router/other/spot"
import userLocations from "@/router/other/userLocations"
import userSegment from "@/router/other/userSegment"
import { RouteRecordRaw } from "vue-router"

export const otherRoutes: RouteRecordRaw[] = [
    ...shareConfig,
    ...karosEvent,
    ...adminUser,
    ...carpoolPlace,
    ...kpiDeployment,
    ...appReleaseEula,
    ...segment,
    ...userSegment,
    ...userLocations,
    ...paymentLogs,
    ...prizes,
    ...promoCodeTemplate,
    ...cancelMatchesPayment,
    ...batchBanUsers,
    ...suspiciousCrews,
    ...spot
]

export default otherRoutes
